module.exports = __webpack_public_path__ + "img/ic_camera2.53d42c8b.svg";